import { render, staticRenderFns } from "./BuyerDetails.vue?vue&type=template&id=50fddf31&scoped=true"
import script from "./BuyerDetails.vue?vue&type=script&lang=js"
export * from "./BuyerDetails.vue?vue&type=script&lang=js"
import style0 from "./BuyerDetails.vue?vue&type=style&index=0&id=50fddf31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fddf31",
  null
  
)

export default component.exports